import slugify from 'slugify';

const DB_SAFE_SLUGIFY_OPTIONS = {
	strict: true,
	replacement: '_',
	trim: false,
} as const;

export function toDbSafeValue(value?: string): string | undefined {
	if (value === undefined) return value;

	return slugify(value, DB_SAFE_SLUGIFY_OPTIONS);
}
